import { Chip, Stack } from "@mui/material";

const manaColorMap = {
  W: { label: "W", colorKey: "white" },
  WHITE: { label: "W", colorKey: "white" },
  U: { label: "U", colorKey: "blue" },
  BLUE: { label: "U", colorKey: "blue" },
  B: { label: "B", colorKey: "black" },
  BLACK: { label: "B", colorKey: "black" },
  R: { label: "R", colorKey: "red" },
  RED: { label: "R", colorKey: "red" },
  G: { label: "G", colorKey: "green" },
  GREEN: { label: "G", colorKey: "green" },
  C: { label: "C", colorKey: "colorless" },
  COLORLESS: { label: "C", colorKey: "colorless" },
} as const;

const normalizeColors = (colors?: string[] | null) => {
  if (!colors || colors.length === 0) {
    return [manaColorMap.COLORLESS];
  }

  return colors
    .map(
      (color) => manaColorMap[color.toUpperCase() as keyof typeof manaColorMap],
    )
    .filter(Boolean);
};

interface ManaIdentityIndicatorProps {
  colors?: string[] | null;
}

const ManaIdentityIndicator = ({ colors }: ManaIdentityIndicatorProps) => {
  const normalizedColors = normalizeColors(colors);

  return (
    <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap">
      {normalizedColors.map(({ label, colorKey }) => {
        const usesDarkText = colorKey === "white" || colorKey === "colorless";

        return (
          <Chip
            key={`${colorKey}-${label}`}
            label={label}
            size="small"
            sx={(theme) => ({
              minWidth: 24,
              width: 24,
              height: 24,
              backgroundColor: theme.mana[colorKey],
              color: usesDarkText ? "#1B1B1B" : "#F8F6D8",
              border: usesDarkText
                ? "1px solid rgba(0,0,0,0.14)"
                : "1px solid rgba(255,255,255,0.08)",
              "& .MuiChip-label": {
                px: 0,
                fontWeight: 700,
              },
            })}
          />
        );
      })}
    </Stack>
  );
};

export default ManaIdentityIndicator;
